import type { Timestamp } from "firebase/firestore";

/** Shared field-coercion helpers for the normalize-on-read layer
 *  (normalizeContact / normalizeEndUser). Each returns a safe default for
 *  anything that isn't the expected shape, so a partial or malformed doc can
 *  never surface `undefined` where a type promises a value. */

export function str(v: unknown): string {
  return typeof v === "string" ? v : "";
}

export function strOrNull(v: unknown): string | null {
  return typeof v === "string" ? v : null;
}

export function numOrNull(v: unknown): number | null {
  return typeof v === "number" ? v : null;
}

export function arr(v: unknown): string[] {
  return Array.isArray(v) ? (v as string[]) : [];
}

/** Duck-typed: anything without a callable `.toDate` (an ISO string, a plain
 *  `{seconds, nanoseconds}` object from a JSON round-trip) collapses to null,
 *  because readers guard with truthiness checks before calling `.toDate()`. */
export function tsOrNull(v: unknown): Timestamp | null {
  return v != null &&
    typeof v === "object" &&
    typeof (v as { toDate?: unknown }).toDate === "function"
    ? (v as Timestamp)
    : null;
}
